import { Stack } from '@ecoinvent/ui';

import ConsumingActivities from 'pages/ConsumingActivities';
import Documentation from 'pages/Documentation';
import Exchanges from 'pages/Exchanges';
import Export from 'pages/Export';
import Flows from 'pages/Flows';
import DatasetHistory from 'pages/History';
import ImpactAssessment from 'pages/ImpactAssessment';
import LCI from 'pages/LCI';
import SupplyChain from 'pages/SupplyChain';

type Props = {
  path: string;
  isLoading: boolean;
  viewMode: 'table' | 'graph';
  supplyChainMode: 'flows' | 'impact_assessment';
};

const renderSelectedTab = (
  path: string,
  viewMode: 'table' | 'graph',
  supplyChainMode: 'flows' | 'impact_assessment',
  isLoading?: boolean
) => {
  if (viewMode === 'graph') {
    return <SupplyChain mode={supplyChainMode} />;
  }
  switch (path) {
    case 'documentation':
      return <Documentation isLoading={isLoading} />;
    case 'exchanges':
      return <Exchanges isLoading={isLoading} />;
    case 'flows':
      return <Flows isLoading={isLoading} />;
    case 'lci':
      return <LCI />;
    case 'impact_assessment':
      return <ImpactAssessment />;
    case 'export':
      return <Export isLoading={isLoading} />;
    case 'consuming_activities':
      return <ConsumingActivities />;
    case 'history':
      return <DatasetHistory />;
    case 'supply-chain':
    default:
      return null;
  }
};

const PrivateDatasetView = ({ path, isLoading, viewMode, supplyChainMode }: Props) => {
  return (
    <Stack width={'100%'} spacing={5}>
      {renderSelectedTab(path, viewMode, supplyChainMode, isLoading)}
    </Stack>
  );
};

export default PrivateDatasetView;
